<template>
  <div>
    <h3>Actions</h3>
    <div class="icon-list" v-bind:class="{ 'width-100': isWidth100}">
      <div v-for="action in actions" :key="action.id" class="amsom-button"
           @click="setSelectedActionAndRedirectToForm(action.id)">
        <button class="btn btn-secondary">
          <i :class="fontawesomeico(action.id)"></i>
        </button>
        <span class="amsom-button-libelle">{{ action.libelle }}</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Actions",
  data() {
    return {
    }
  },
  methods: {
    setSelectedActionAndRedirectToForm(actionID) {
      this.$store.dispatch('actions/setSelectedAction', actionID)
      this.$router.push({name: 'formulairesuivi'})
    },
    fontawesomeico(ID) {
      if (ID === "TECH") return 'fas fa-tools'
      return 'fas fa-cog'
    }
  },
  computed: {
    actions() {
      return this.$store.getters['actions/iCanWrite'].filter(action => action.evenement === this.$store.getters['evenements/selectedEvenement'])
    },
    isWidth100() {
      if (this.actions.length < 4) return true
      return false
    }
  },
  mounted() {
    this.$store.dispatch('actions/setSelectedAction', null)

    if (this.actions.length === 1){
      this.$store.dispatch('actions/setSelectedAction', this.actions[0].id)
      this.$router.push({
        name: 'formulairesuivi'
      });
    }
  }
}
</script>

<style scoped>

</style>